<br><br>
<div class="container">
    <div class="col-xs-12">
        <div class="animated fadeIn mt-5">
            <form [formGroup]="Unsubsribe " name="Unsubsribe" id="Unsubsribe"
                (ngSubmit)="Unsubsribedata(Unsubsribe.value)" autocomplete="off" novalidate>
                <h2 style="margin-bottom: 3px;margin-top: 24px; font-size: 0.9970rem">Unsubsribe Email </h2>
                <br>
                <div class="input-group-lg">

                    <div class="row">

                        <!-- <div class="col-md-4">
                            <mat-form-field class="w-100">
                                <input matInput formControlName="emailAddress" name="emailAddress" placeholder="New Password"
                                   >
                               
                            </mat-form-field>
                
                        </div> -->
                        <div class="col-12 col-sm-4">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Email</mat-label>
                                <input matInput name="Email" [(ngModel)]="getEmailAddress" formControlName="Email"  readonly>

                            </mat-form-field>
                        </div>
                        <div style="margin-top:2rem;" class="cent">
                            <button mat-flat-button color="primary" type="submit"
                                class="loginbtn mr-2">Unsubsribed</button>
                        </div>
                    </div>
                </div>

                <br>


                <!-- <div style="margin-top:2rem;" class="cent">
    <button mat-flat-button color="primary" type="submit" class="loginbtn mr-2">Unsubsribed</button>&nbsp;
   
  </div> -->

            </form>
        </div>
    </div>
</div>